import React from 'react';
// import Container from '@mui/material/Container';
import { Grid, Box, Typography, Link } from '@mui/material';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import YouTubeIcon from '@mui/icons-material/YouTube';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { useLocation } from 'react-router-dom';
// import DreamCarIcon from '../../components/appFooterIcons/dreamCar';

// import HomeIcon from '../../components/appFooterIcons/home';
// import BuyIcon from '../../components/appFooterIcons/buy';
// import SellIcon from '../../components/appFooterIcons/sell';

// import ReviewCard from '../../segment/@common/Review/reviewCard';
// import { useDevice } from '../../hooks/useResponsive';

const SpecialFooter = () => {
  // const navigate = useNavigate();
  // const { isMobile } = useDevice();
  const location = useLocation();
  // const isTablet = window.innerWidth <= 768;
  // console.log(isTablet)
  // console.log(location?.pathname);
  // const isProductSinglePage = /^\/product-single\/[a-zA-Z0-9]+$/.test(location?.pathname);
  // console.log(isProductSinglePage);

  // const handleScrollToTop = () => {
  //   navigate('/search');
  // };

  // console.log(isMobile);

  // const [scrollValue, setScrollValue] = useState();

  // React.useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollValue = window.scrollY;
  //     setScrollValue(scrollValue);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // console.log('data :', scrollValue);

  // const footerItems = [
  //   {
  //     itemName: 'Home',
  //     link: '/home',
  //   },
  //   {
  //     itemName: 'Products',
  //     link: '/products',
  //   },

  //   {
  //     itemName: 'Estimate',
  //     link: '/estimate',
  //   },
  //   {
  //     itemName: 'About',
  //     link: '/about',
  //   },
  // ];

  const footerItemsMobile = [
    {
      itemName: 'Home',
      pathName: '/inspection',
      activeImage: '/assets/images/iconImages/yellowHome.png',
      inActiveImage: '/assets/images/iconImages/greyHome.png',
      alt: '1',
    },
    {
      itemName: 'Inspection',
      pathName: '/inspection-booking',
      activeImage: '/assets/images/iconImages/iconInspection.png',
      inActiveImage: '/assets/images/iconImages/inspectionGrey.png',
      alt: '2',
    },
    {
      itemName: 'Report',
      pathName: '/verify',
      activeImage: '/assets/images/iconImages/reportYellow.png',
      inActiveImage: '/assets/images/iconImages/reportGrey.png',
      alt: '3',
    },
  ];

  return (
    <>
      {/* white section */}
      <Grid
        container
        spacing={1}
        className="app-bar"
        sx={{
          padding: '5px 13px',
          display: { sx: 'flex', sm: 'none' },
          flexDirection: { sx: 'row' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 4500,
          backgroundColor: 'white',
          // borderRadius: '10px',
          boxShadow: '0px -3px 6px 0px #3333331A',

          justifyContent: 'space-between',
          width: '100%',
          margin: 'auto',
        }}
      >
        {/* {footerItemsMobile?.map((item, key) => (
          <Grid key={key} display="flex" alignItems="center" px={5}>
            <Link href={item?.pathName} style={{ textDecoration: 'none' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'column' },
                  alignItems: 'center',
                  marginLeft: '5px',
                }}
              >
                <Box
                  component="img"
                  src={location.pathname === item.pathName ? item.activeImage : item.inActiveImage}
                  alt={item.alt}
                  sx={{ width: item?.pathName==='/inspection'?25:30, height: 26, mb: 0.5,objectFit:'cover' }}
                />

                <Typography
                  textAlign={'center'}
                  fontSize={12}
                  fontWeight={600}
                  sx={{ color: location.pathname === item.pathName ? '#ED8100' : '#333333' }}
                >
                  {' '}
                  {item?.itemName}
                </Typography>
              </Box>
            </Link>
          </Grid>
        ))} */}
        {footerItemsMobile?.map((item, key) => {
          const isActive =
            item.itemName === 'Inspection'
              ? ['/inspection-booking', '/booking'].includes(location.pathname)
              : location.pathname === item.pathName;

          return (
            <Grid key={key} display="flex" alignItems="center" px={3}>
              <Link href={item?.pathName} style={{ textDecoration: 'none' }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'column' },
                    alignItems: 'center',
                    marginLeft: '5px',
                  }}
                >
                  <Box
                    component="img"
                    src={isActive ? item.activeImage : item.inActiveImage}
                    alt={item.alt}
                    sx={{ width: item?.pathName === '/inspection' ? 25 : 30, height: 26, mb: 0.5, objectFit: 'cover' }}
                  />

                  <Typography
                    textAlign="center"
                    fontSize={12}
                    fontWeight={600}
                    sx={{ color: isActive ? '#ED8100' : '#333333' }}
                  >
                    {item.itemName}
                  </Typography>
                </Box>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default SpecialFooter;
